import { useState } from "react";
import { useLocation } from "react-router-dom";
import logo from "../assets/logo.png";
import "./Navbar.css";
import AnchorLink from "react-anchor-link-smooth-scroll";
import { NavLink } from "react-router-dom";

function NavBar() {
    const [navOpen, setNavOpen] = useState(false);
    const location = useLocation();

    const openNav = () => {
        setNavOpen(!navOpen);
    };


    const renderLink = (to, label) => {

        return location.pathname === "/" ? (
            <AnchorLink href={to} className="menu" onClick={() => setNavOpen(false)}>
                {label}
            </AnchorLink>
        ) : (
            <NavLink to="/" className="menu" onClick={() => setNavOpen(false)}>
                {label}
            </NavLink>
        );
    };

    return (
        <nav className="container navbar flex justify-between items-center">
            <NavLink to="/">
                <img src={logo} className="h-32" alt="247comcare logo" />
            </NavLink>

            <div className={`nav-menu ${navOpen && "open"}`}>
                {renderLink("#home", "Home")}
                {renderLink("#about", "About")}
                {renderLink("#services", "Services")}
                {renderLink("#contact", "Contact Us")}
            </div>
            <div className={`nav-toggle ${navOpen && "open"}`} onClick={openNav}>
                <div className="bar"></div>
            </div>
        </nav>
    );
}
export default NavBar;